import React, { useState } from "react";
import AppUnlockModal from "../components/common/AppUnlockModal";
import { HomePageMarketingFooter, HomePageMarketingHeader } from "../components/common/HomePageChrome";

function siteName() {
  return (process.env.REACT_APP_SITE_NAME || "Vibes Reserve").trim();
}

function bootstrapFooterFallback() {
  const year = new Date().getFullYear();
  const name = siteName();
  return (
    <footer className="site-footer border-top mt-auto">
      <div className="container py-4 px-3 px-md-4">
        <p className="site-footer__text mb-0 small text-center">
          © {year} {name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

/**
 * Website shell: marketing header/footer by default on all routes; optional overrides.
 *
 * Props:
 * - `beforeMain` — if **undefined**, renders marketing header when `marketingChrome` is true; pass explicit `null` for no header, or a React node for a custom header.
 * - `footerSlot` — if **undefined**, renders marketing footer when `marketingChrome` is true; pass a React node for a custom footer.
 * - `marketingChrome` — when false (and no overrides), restores simple Bootstrap-style footer only.
 */
export default function WebsiteLayout({
  children,
  beforeMain,
  footerSlot,
  marketingChrome = true,
}) {
  const [showBecomeHostModal, setShowBecomeHostModal] = useState(false);

  const headerEl =
    beforeMain !== undefined
      ? beforeMain
      : marketingChrome && (
          <HomePageMarketingHeader onBecomeHost={() => setShowBecomeHostModal(true)} />
        );

  const footerEl =
    footerSlot !== undefined ? footerSlot : marketingChrome ? <HomePageMarketingFooter /> : bootstrapFooterFallback();

  return (
    <div className="site-root d-flex flex-column min-vh-100">
      {headerEl}
      <main className="site-main flex-grow-1">{children}</main>
      {footerEl}
      {marketingChrome ? (
        <AppUnlockModal
          open={showBecomeHostModal}
          onClose={() => setShowBecomeHostModal(false)}
          title="Become a Host"
          message="List your club or event, reach nearby guests faster, manage bookings, and grow your nightlife business with VibeReserve."
        />
      ) : null}
    </div>
  );
}
